const allTz = [
  'Europe/Paris',
  'Europe/Brussels',
  'America/Cayenne',
  'Indian/Reunion',
  'Africa/Casablanca',
  'Europe/Berlin',
  'Indian/Mayotte',
  'America/Guadeloupe',
  'Pacific/Noumea',
  'Pacific/Tahiti',
  'Africa/Nairobi',
  'Europe/Madrid',
  'America/Martinique',
  'Indian/Mauritius',
  'Asia/Dubai',
  'Europe/Warsaw',
  'America/La_Paz',
  'Europe/Zurich',
  'Africa/Abidjan',
  'Africa/Tunis',
  'Africa/Algiers',
  'America/Los_Angeles',
  'Africa/Kigali',
  'Europe/London',
  'Europe/Rome',
  'Africa/Cairo',
  'Africa/Lagos',
  'Europe/Amsterdam',
  'Pacific/Honolulu',
  'Europe/Lisbon',
  'Pacific/Guadalcanal',
  'America/Caracas',
  'America/Montreal',
  'America/New_York',
  'America/Toronto',
  'America/Mexico_City',
  'Europe/Luxembourg',
  'America/El_Salvador',
  'Asia/Riyadh',
  'Atlantic/Canary',
  'Africa/Dakar',
  'America/Halifax',
  'Asia/Tbilisi',
  'Africa/Djibouti',
  'Asia/Shanghai',
  'America/Buenos_Aires',
  'America/Sao_Paulo',
  'Asia/Beirut',
  'Europe/Sarajevo',
  'Atlantic/Reykjavik',
  'America/Miquelon',
  'Africa/Bamako',
  'America/Fortaleza',
  'Europe/Budapest',
  'Africa/Libreville',
  'Europe/Moscow',
  'Europe/Istanbul',
  'Africa/Johannesburg',
  'Africa/Addis_Ababa',
  'Asia/Tokyo',
  'Pacific/Wallis',
  'America/Guatemala',
  'Asia/Qatar',
  'America/Port-au-Prince',
  'Europe/Bucharest',
  'America/Chicago',
  'Europe/Zagreb',
  'Europe/Kiev',
  'America/Guyana',
  'America/Bogota',
  'Europe/Vienna',
  'America/Marigot',
  'Indian/Antananarivo',
  'America/Santiago',
  'America/Manaus',
  'Asia/Baghdad',
  'Asia/Sakhalin',
  'Asia/Singapore',
  'Europe/Vilnius',
  'Africa/Dar_es_Salaam',
  'Asia/Calcutta',
  'Europe/Oslo',
  'Asia/Phnom_Penh',
  'Asia/Amman',
  'Europe/Sofia',
  'Asia/Tehran',
  'Australia/Sydney',
  'Asia/Bangkok',
  'America/Barbados',
  'America/St_Barthelemy',
  'Europe/Copenhagen',
  'Africa/Windhoek',
  'America/Phoenix',
  'Africa/Luanda',
  'America/Curacao',
  'Africa/Asmara',
  'Europe/Stockholm',
  'Asia/Vientiane',
  'America/Asuncion',
  'Africa/Nouakchott',
  'America/Panama',
  'Atlantic/Azores',
  'Europe/Astrakhan',
  'Africa/Accra',
  'Europe/Mariehamn',
  'Asia/Yerevan',
  'Europe/Monaco',
  'America/Anchorage',
  'Africa/Blantyre',
  'America/Edmonton',
  'Indian/Chagos',
  'Europe/Dublin',
  'Atlantic/St_Helena',
  'Pacific/Kiritimati',
  'Atlantic/Cape_Verde',
  'Israel',
  'Africa/Bujumbura',
  'Australia/Adelaide',
  'Africa/Niamey',
  'America/Lower_Princes',
  'Pacific/Efate',
  'Europe/Nicosia',
  'Indian/Comoro',
  'Europe/Andorra',
  'Canada/Eastern',
  'Asia/Kabul',
  'Asia/Manila',
  'Europe/Bratislava',
  'Europe/Athens',
  'Atlantic/Bermuda',
  'Africa/Douala',
  'America/Montevideo',
  'Africa/Ouagadougou',
  'America/Lima',
  'America/Puerto_Rico',
  'Europe/Volgograd',
  'Asia/Seoul',
  'America/Paramaribo',
  'Africa/Harare',
  'Asia/Jerusalem',

  'Europe/Tirane',
  'Antarctica/Casey',
  'Antarctica/Davis',
  'Antarctica/DumontDUrville', // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
  'Antarctica/Mawson',
  'Antarctica/Palmer',
  'Antarctica/Rothera',
  'Antarctica/Syowa',
  'Antarctica/Troll',
  'Antarctica/Vostok',
  'America/Argentina/Cordoba',
  'America/Argentina/Salta',
  'America/Argentina/Jujuy',
  'America/Argentina/Tucuman',
  'America/Argentina/Catamarca',
  'America/Argentina/La_Rioja',
  'America/Argentina/San_Juan',
  'America/Argentina/Mendoza',
  'America/Argentina/San_Luis',
  'America/Argentina/Rio_Gallegos',
  'America/Argentina/Ushuaia',
  'Pacific/Pago_Pago',
  'Australia/Lord_Howe',
  'Antarctica/Macquarie',
  'Australia/Hobart',
  'Australia/Currie',
  'Australia/Melbourne',
  'Australia/Broken_Hill',
  'Australia/Brisbane',
  'Australia/Lindeman',
  'Australia/Darwin',
  'Australia/Perth',
  'Australia/Eucla',
  'Asia/Baku',
  'Asia/Dhaka',
  'Asia/Brunei',
  'America/Noronha',
  'America/Belem',
  'America/Recife',
  'America/Araguaina',
  'America/Maceio',
  'America/Bahia',
  'America/Campo_Grande',
  'America/Cuiaba',
  'America/Santarem',
  'America/Porto_Velho',
  'America/Boa_Vista',
  'America/Eirunepe',
  'America/Rio_Branco',
  'America/Nassau',
  'Asia/Thimphu',
  'Europe/Minsk',
  'America/Belize',
  'America/St_Johns',
  'America/Glace_Bay',
  'America/Moncton',
  'America/Goose_Bay',
  'America/Blanc-Sablon',
  'America/Nipigon',
  'America/Thunder_Bay',
  'America/Iqaluit',
  'America/Pangnirtung',
  'America/Atikokan',
  'America/Winnipeg',
  'America/Rainy_River',
  'America/Resolute',
  'America/Rankin_Inlet',
  'America/Regina',
  'America/Swift_Current',
  'America/Cambridge_Bay',
  'America/Yellowknife',
  'America/Inuvik',
  'America/Creston',
  'America/Dawson_Creek',
  'America/Fort_Nelson',
  'America/Vancouver',
  'America/Whitehorse',
  'America/Dawson',
  'Indian/Cocos',
  'Pacific/Rarotonga',
  'America/Punta_Arenas',
  'Pacific/Easter',
  'Asia/Urumqi',
  'America/Costa_Rica',
  'America/Havana',
  'Indian/Christmas',
  'Asia/Famagusta',
  'Europe/Prague',
  'America/Santo_Domingo',
  'America/Guayaquil',
  'Pacific/Galapagos',
  'Europe/Tallinn',
  'Africa/El_Aaiun',
  'Africa/Ceuta',
  'Europe/Helsinki',
  'Pacific/Fiji',
  'Atlantic/Stanley',
  'Pacific/Chuuk',
  'Pacific/Pohnpei',
  'Pacific/Kosrae',
  'Atlantic/Faroe',
  'Europe/Gibraltar',
  'America/Godthab',
  'America/Danmarkshavn',
  'America/Scoresbysund',
  'America/Thule',
  'Atlantic/South_Georgia',
  'Pacific/Guam',
  'Africa/Bissau',
  'Asia/Hong_Kong',
  'America/Tegucigalpa',
  'Asia/Jakarta',
  'Asia/Pontianak',
  'Asia/Makassar',
  'Asia/Jayapura',
  'Asia/Kolkata',
  'America/Jamaica',
  'Asia/Bishkek',
  'Pacific/Tarawa',
  'Pacific/Enderbury',
  'Asia/Pyongyang',
  'Asia/Almaty',
  'Asia/Qyzylorda',
  'Asia/Qostanay', // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
  'Asia/Aqtobe',
  'Asia/Aqtau',
  'Asia/Atyrau',
  'Asia/Oral',
  'Asia/Colombo',
  'Africa/Monrovia',
  'Europe/Riga',
  'Africa/Tripoli',
  'Europe/Chisinau',
  'Pacific/Majuro',
  'Pacific/Kwajalein',
  'Asia/Yangon',
  'Asia/Ulaanbaatar',
  'Asia/Hovd',
  'Asia/Choibalsan',
  'Asia/Macau',
  'Europe/Malta',
  'Indian/Maldives',
  'America/Cancun',
  'America/Merida',
  'America/Monterrey',
  'America/Matamoros',
  'America/Mazatlan',
  'America/Chihuahua',
  'America/Ojinaga',
  'America/Hermosillo',
  'America/Tijuana',
  'America/Bahia_Banderas',
  'Asia/Kuala_Lumpur',
  'Asia/Kuching',
  'Africa/Maputo',
  'Pacific/Norfolk',
  'America/Managua',
  'Asia/Kathmandu',
  'Pacific/Nauru',
  'Pacific/Niue',
  'Pacific/Auckland',
  'Pacific/Chatham',
  'Pacific/Marquesas',
  'Pacific/Gambier',
  'Pacific/Port_Moresby',
  'Pacific/Bougainville',
  'Asia/Karachi',
  'Pacific/Pitcairn',
  'Asia/Gaza',
  'Asia/Hebron',
  'Atlantic/Madeira',
  'Pacific/Palau',
  'Europe/Belgrade',
  'Europe/Kaliningrad',
  'Europe/Simferopol',
  'Europe/Kirov',
  'Europe/Saratov',
  'Europe/Ulyanovsk',
  'Europe/Samara',
  'Asia/Yekaterinburg',
  'Asia/Omsk',
  'Asia/Novosibirsk',
  'Asia/Barnaul',
  'Asia/Tomsk',
  'Asia/Novokuznetsk',
  'Asia/Krasnoyarsk',
  'Asia/Irkutsk',
  'Asia/Chita',
  'Asia/Yakutsk',
  'Asia/Khandyga',
  'Asia/Vladivostok',
  'Asia/Ust-Nera',
  'Asia/Magadan',
  'Asia/Srednekolymsk',
  'Asia/Kamchatka',
  'Asia/Anadyr',
  'Indian/Mahe',
  'Africa/Khartoum',
  'Africa/Juba',
  'Africa/Sao_Tome',
  'Asia/Damascus',
  'America/Grand_Turk',
  'Africa/Ndjamena',
  'Indian/Kerguelen',
  'Asia/Dushanbe',
  'Pacific/Fakaofo',
  'Asia/Dili',
  'Asia/Ashgabat',
  'Pacific/Tongatapu',
  'America/Port_of_Spain',
  'Pacific/Funafuti',
  'Asia/Taipei',
  'Europe/Uzhgorod',
  'Europe/Zaporozhye',
  'Pacific/Wake',
  'America/Detroit',
  'America/Kentucky/Louisville',
  'America/Kentucky/Monticello',
  'America/Indiana/Indianapolis',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Indiana/Marengo',
  'America/Indiana/Petersburg',
  'America/Indiana/Vevay',
  'America/Indiana/Tell_City',
  'America/Indiana/Knox',
  'America/Menominee',
  'America/North_Dakota/Center',
  'America/North_Dakota/New_Salem',
  'America/North_Dakota/Beulah',
  'America/Denver',
  'America/Boise',
  'America/Juneau',
  'America/Sitka',
  'America/Metlakatla',
  'America/Yakutat',
  'America/Nome',
  'America/Adak',
  'Asia/Samarkand',
  'Asia/Tashkent',
  'Asia/Ho_Chi_Minh',
  'Pacific/Apia',
];

export function guessTZ() {
  const guess = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
  return allTz.includes(guess) ? guess : 'Europe/Paris';
}

export default allTz;
